import type { FinanceInfo } from '~/contracts/srp';
import FinanceInfoFromApi from '~/services/contracts/FinanceInfo';

export default function formatFinanceInfo(
  financeInfo: FinanceInfoFromApi
): FinanceInfo {
  return {
    ...financeInfo,
    minDownPaymentNoTrade: financeInfo.minDownPaymentNoTrade ?? undefined
  };
}
